import { fetchMetricDataGames } from '@intelligence/v3/services/topCharts';
import { buildMetricFiltersFetchParams, buildSensorTowerTagsParams } from '@intelligence/v3/utils/topcharts';
import { SortType, SortMode } from '@home/enums/common';
import { generateSortMetricKeys } from '@intelligence/v3/utils/metric';
import { DATASOURCE_KEY_MAP, SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';
import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';

/**
 * 合并游戏详情信息
 * @param games 游戏列表
 * @param gameDetailsMap 游戏详情映射
 * @return 游戏列表（每个游戏都合并了详情信息）
 */
const mergeGameDetailsData = (
  games?: IMetricDataGame[] | null,
  gameDetailsMap?: IRecord<IRecord> | null,
): IMetricDataGame[] => {
  if (!Array.isArray(games) || games?.length === 0) {
    return [];
  }

  if (!gameDetailsMap) {
    return games;
  }

  return games.map((game) => {
    const gameId = game?.game_id || '';
    const gameDetails = gameDetailsMap?.[gameId] || {};
    return { ...game, ...gameDetails };
  });
};

class MobileOverlapTopChartsService {
  static convertFetchParams(params?: IRecord, isSearchMode = false): IMetricDataGamesFetchParams {
    const gameIds = params?.search_game_code || [];
    const orderBys = generateSortMetricKeys([
      {
        dataSource: params?.order_source || DATASOURCE_KEY_MAP.SENSORTOWER,
        metric: params?.order_metric || SENSORTOWER_METRIC_KEY_MAP.ACTIVE_USERS,
        type: params?.order || SortType.Desc,
        mode: params?.ratio_type ?? SortMode.Number,
      },
    ]);
    const metricFilter = buildMetricFiltersFetchParams([
      { metric: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE, metricValue: params?.mobile_overlap },
    ]);

    return {
      filter: {
        iegg_genre: params?.iegg_genre || [],
        sensortower_genre: params?.sensortower_genre || [],
        appannie_genre: params?.appannie_genre || [],
        metric_filter: metricFilter,
        tags: buildSensorTowerTagsParams(params?.sensortower_tag_filter),
        companies: params?.company || [],
        start_release_date: params?.start_release_time || '',
        end_release_date: params?.end_release_time || '',
      },
      markets: params?.markets || [],
      platforms: params?.platforms || ['appstore', 'googleplay'],
      metrics: [
        DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS,
        DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
        DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
      ],
      granularity: params?.date_type || 'monthly',
      start_date: params?.start_date || '',
      end_date: params?.end_date || '',
      group_by: ['game_id'],
      order_by: orderBys,
      page: params?.page || 1,
      page_size: isSearchMode ? 9999 : params?.page_size || 100,
      keyword: params?.search_by_name || '',
      game_ids: isSearchMode ? [] : gameIds,
      rank_game_ids: isSearchMode ? gameIds : [],
      top_size: 4,
      use_custom_fields: params?.use_custom_fields || [],
    };
  }

  static formatResponse<T extends IUnwrapPromise<IBaseResponse<IPaginationData<IMetricDataGame>>>>(response: T): T {
    const ext = response?.ext || {};
    const gameDetailsMap = ext?.entity_info || {};
    const responseData = response?.data || {};
    const list = responseData?.list || [];
    const newList = mergeGameDetailsData(list, gameDetailsMap);
    const newResponseData = { ...responseData, list: newList };
    return { ...response, data: newResponseData };
  }

  static async fetchMobileOverlapTopChartsList(params?: IRecord, isSearchMode = false) {
    const newParams = MobileOverlapTopChartsService.convertFetchParams(params, isSearchMode);
    // const response = await fetchMetricDataGames(newParams);
    const response = await fetchMetricDataGames(newParams);
    return MobileOverlapTopChartsService.formatResponse(response);
  }
}

export default MobileOverlapTopChartsService;
